import { EmptyFilteredResult } from "app/pages/activation/components/ProjectsList/States/EmptyFIlteredResult";
import { EmptyProjectsList } from "app/pages/activation/components/ProjectsList/States/EmptyProjectsList/EmptyProjectsList";
import { EmptyStateFoldersVariant } from "app/pages/activation/components/ProjectsList/States/EmptyStateFoldersVariant/EmptyStateFoldersVariant";
import { ErrorState } from "app/pages/activation/components/ProjectsList/States/ErrorState";

import { EmptyStateBanner } from "../../EmptyStateBunner/EmptyStateBunner";

export enum States {
    EmptyFilteredResult = "emptyFilteredResult",
    Empty = "empty",
    EmptyVariant = "emptyVariant",
    EmptyList = "emptyList",
    Error = "error",
}

type ListStatesSchema = {
    state: States;
    onClickCreateProject?: () => void;
    listWidth?: number;
};

export const ListStates = ({ state, onClickCreateProject, listWidth }: ListStatesSchema) => {
    if (state === States.Empty) {
        return <EmptyStateBanner onClick={onClickCreateProject} />;
    }

    if (state === States.EmptyFilteredResult) {
        return <EmptyFilteredResult />;
    }

    if (state === States.EmptyVariant) {
        return <EmptyStateFoldersVariant onClick={onClickCreateProject} />;
    }

    if (state === States.EmptyList) {
        return (
            <EmptyProjectsList
                onClick={onClickCreateProject}
                listWidth={listWidth}
            />
        );
    }

    return <ErrorState />;
};
